import type { ContractEditView } from "@buildpy/core/views/g2a/contract-edit";
import ContractEditor from "@/modules/contract/ui/contract-editor";

// 계약 초안 편집. 발송한 뒤에는 고칠 수 없으므로 상세로 돌려보낸다.
const Page = ({ data }: { data: ContractEditView }) => {
  const { contract, payments } = data;
  return (
    <ContractEditor
      baseRev={contract.rev}
      clauseSource={contract.clause_source}
      contractId={contract.id}
      contractNo={contract.contract_no}
      endDate={contract.end_date}
      payments={payments.map((p) => ({
        label: p.label,
        ratio_bp: p.ratio_bp,
        trigger_text: p.trigger_text,
        trigger_phase_id: p.trigger_phase_id,
        due_date: p.due_date,
        note: p.note,
      }))}
      rates={{
        delay_rate_bp: contract.delay_rate_bp,
        delay_cap_bp: contract.delay_cap_bp,
        late_interest_rate_bp: contract.late_interest_rate_bp,
      }}
      specialTerms={contract.special_terms}
      startDate={contract.start_date}
      totalAmount={contract.total_amount}
      vatIncluded={contract.vat_included}
    />
  );
};

export default Page;
